<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
    :class="[color === 'light' ? 'bg-white' : 'bg-green-900 text-white']"
  >
    <div class="rounded-t mb-4 mt-6 px-6 py-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1">
          <h3
            class="text-lg"
            :class="[color === 'light' ? 'text-gray-800' : 'text-white']"
          >
            Review Insurance Rules
          </h3>
        </div>
      </div>
    </div>

    <div class="block w-full overflow-x-auto md:px-12 lg:px-12">
      <!-- Projects table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <tbody>
          <tr>
            <th
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-base whitespace-no-wrap p-4 text-left flex items-center"
            >
              <i
                class="far fa-check-square text-green-600 font-bold text-xl"
              ></i>
              <span
                class="ml-3 font-bold"
                :class="[color === 'light' ? 'text-gray-700' : 'text-white']"
              >
                Maximum Duration
              </span>
            </th>

            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <div class="flex items-center">
                <span
                  class="mr-2 bg-green-200 p-1 px-3 rounded-full text-green-600 font-bold"
                  >UP TO 3 YEARS</span
                >
              </div>
            </td>

            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <div class="flex items-center">
                <button
                  ref="btnRef"
                  v-on:click="togglePopover()"
                  class="text-dark fa fa-question font-bold text-sm p-2 rounded-full mr-1 mb-1"
                  type="button"
                ></button>
                <div
                  ref="popoverRef"
                  v-bind:class="{'hidden': !popoverShow, 'block': popoverShow}"
                  class="bg-emerald-600 border-0 mr-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words bg-dark-bgbb100 rounded-lg"
                >
                  <div>
                    <div
                      class="bg-emerald-600 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-blueGray-100 uppercase rounded-t-lg"
                    >
                      emerald popover title
                    </div>
                    <div class="text-white p-3">
                      And here's some amazing content. It's very engaging.
                      Right?
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-no-wrap p-4 text-left flex items-center"
            >
              <i
                class="far fa-check-square text-green-600 font-bold text-xl"
              ></i>
              <span
                class="ml-3 font-bold"
                :class="[color === 'light' ? 'text-gray-700' : 'text-white']"
              >
                Insurance Coverage
              </span>
            </th>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <span
                class="mr-2 bg-green-200 p-1 px-3 rounded-full text-green-600 font-bold"
                >90% OF STAKE*</span
              >
            </td>

            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <div class="flex items-center">
                <button
                  ref="btnRef2"
                  v-on:click="togglePopover2()"
                  class="text-dark fa fa-question font-bold text-sm p-2 rounded-full mr-1 mb-1"
                  type="button"
                ></button>
                <div
                  ref="popoverRef2"
                  v-bind:class="{'hidden': !popoverShow2, 'block': popoverShow2}"
                  class="bg-emerald-600 border-0 mr-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words bg-dark-bgbb100 rounded-lg"
                >
                  <div>
                    <div
                      class="bg-emerald-600 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-blueGray-100 uppercase rounded-t-lg"
                    >
                      2222
                    </div>
                    <div class="text-white p-3">22222</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <th
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-no-wrap p-4 text-left flex items-center"
            >
              <i class="far fa-times-circle text-red-500 font-bold text-xl"></i>

              <span
                class="ml-3 font-bold"
                :class="[color === 'light' ? 'text-gray-700' : 'text-white']"
              >
                Scraping Rewards
              </span>
            </th>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <span
                class="mr-2 bg-red-200 p-1 px-3 rounded-full text-red-500 font-bold"
                >DISABLED</span
              >
            </td>

            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <div class="flex items-center">
                <button
                  ref="btnRef3"
                  v-on:click="togglePopover3()"
                  class="text-dark fa fa-question font-bold text-sm p-2 rounded-full mr-1 mb-1"
                  type="button"
                ></button>
                <div
                  ref="popoverRef3"
                  v-bind:class="{'hidden': !popoverShow3, 'block': popoverShow3}"
                  class="bg-emerald-600 border-0 mr-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words bg-dark-bgbb100 rounded-lg"
                >
                  <div>
                    <div
                      class="bg-emerald-600 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-blueGray-100 uppercase rounded-t-lg"
                    >
                      emerald popover title
                    </div>
                    <div class="text-white p-3">
                      And here's some amazing content. It's very engaging.
                      Right?
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <th
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-no-wrap p-4 text-left flex items-center"
            >
              <i class="far fa-times-circle text-red-500 font-bold text-xl"></i>

              <span
                class="ml-3 font-bold"
                :class="[color === 'light' ? 'text-gray-700' : 'text-white']"
              >
                Cancel Pending Stake
              </span>
            </th>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <span
                class="mr-2 bg-red-200 p-1 px-3 rounded-full text-red-500 font-bold"
                >DISABLED</span
              >
            </td>

            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <div class="flex items-center">
                <button
                  ref="btnRef4"
                  v-on:click="togglePopover4()"
                  class="text-dark fa fa-question font-bold text-sm p-2 rounded-full mr-1 mb-1"
                  type="button"
                ></button>
                <div
                  ref="popoverRef4"
                  v-bind:class="{'hidden': !popoverShow4, 'block': popoverShow4}"
                  class="bg-emerald-600 border-0 mr-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words bg-dark-bgbb100 rounded-lg"
                >
                  <div>
                    <div
                      class="bg-emerald-600 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-blueGray-100 uppercase rounded-t-lg"
                    >
                      444
                    </div>
                    <div class="text-white p-3">444</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <th
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-no-wrap p-4 text-left flex items-center"
            >
              <i
                class="far fa-check-square text-orange-500 font-bold text-xl"
              ></i>

              <span
                class="ml-3 font-bold"
                :class="[color === 'light' ? 'text-gray-700' : 'text-white']"
              >
                Insurance Deposit
              </span>
            </th>
            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <span
                class="mr-2 bg-orange-200 p-1 px-3 rounded-full text-orange-500 font-bold"
                >10% OF STAKE
              </span>
            </td>

            <td
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4"
            >
              <div class="flex items-center">
                <button
                  ref="btnRef5"
                  v-on:click="togglePopover5()"
                  class="text-dark fa fa-question font-bold text-sm p-2 rounded-full mr-1 mb-1"
                  type="button"
                ></button>
                <div
                  ref="popoverRef5"
                  v-bind:class="{'hidden': !popoverShow5, 'block': popoverShow5}"
                  class="bg-emerald-600 border-0 mr-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words bg-dark-bgbb100 rounded-lg"
                >
                  <div>
                    <div
                      class="bg-emerald-600 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-blueGray-100 uppercase rounded-t-lg"
                    >
                      5
                    </div>
                    <div class="text-white p-3">5</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="relative w-full mobile:px-4 md:px-12 py-6 max-w-full flex-grow flex-1">
        <p class="text-justify text-sm">
          <i class="fas fa-calendar-times"> </i>
          <strong> Refund Conditions:</strong> <br />

          Insurance stakes that are ended early receive 90% of principal back
          and no interest. Insurance stakes carried out to maturity receive 100%
          of principal back plus interest.
          <a href="#" class="text-xs bg-gray-300 p-1">Learn More</a>
        </p>
      </div>

      <div class="flex flex-wrap text-center justify-center mb-12">
        <a
          href="#"
          target="_self"
          class="shadow-xl font-semibold text-white mx-10 py-4 rounded outline-none focus:outline-none mb-1 bg-dark-bgbb100 text-sm container"
        >
          APPROVE INSURANCE CONTRACT
        </a>
      </div>
    </div>
  </div>
</template>
<script>

import { createPopper } from "@popperjs/core";

// import TableDropdown from "@/components/Dropdowns/TableDropdown.vue";

// import bootstrap from "@/assets/img/bootstrap.jpg";
// import angular from "@/assets/img/angular.jpg";
// import sketch from "@/assets/img/sketch.jpg";
// import react from "@/assets/img/react.jpg";
// import vue from "@/assets/img/react.jpg";

// import team1 from "@/assets/img/team-1-800x800.jpg";
// import team2 from "@/assets/img/team-2-800x800.jpg";
// import team3 from "@/assets/img/team-3-800x800.jpg";
// import team4 from "@/assets/img/team-4-470x470.png";

export default {
  name: "top-emerald-tooltip",
  data() {
    return {
       popoverShow: false,
       popoverShow2: false,
      popoverShow3: false,
      popoverShow4: false,
      popoverShow5: false,
      // bootstrap,
      // angular,
      // sketch,
      // react,
      // vue,
      // team1,
      // team2,
      // team3,
      // team4,
    };
  },

 methods: {
    togglePopover: function(){
      if(this.popoverShow){
        this.popoverShow = false;
      } else {
        this.popoverShow = true;
        createPopper(this.$refs.btnRef, this.$refs.popoverRef, {
          placement: "top"
        });
      }
    },
     togglePopover2: function(){
       if(this.popoverShow2){
        this.popoverShow2 = false;
      } else {
        this.popoverShow2 = true;
        createPopper(this.$refs.btnRef2, this.$refs.popoverRef2, {
          placement: "top"
        });
      }
    },

     togglePopover3: function(){
      if(this.popoverShow3){
        this.popoverShow3 = false;
      } else {
        this.popoverShow3 = true;
        createPopper(this.$refs.btnRef3, this.$refs.popoverRef3, {
          placement: "top"
        });
      }
    },


     togglePopover4: function(){
      if(this.popoverShow4){
        this.popoverShow4 = false;
      } else {
        this.popoverShow4 = true;
        createPopper(this.$refs.btnRef4, this.$refs.popoverRef4, {
          placement: "top"
        });
      }
    },


     togglePopover5: function(){
      if(this.popoverShow5){
        this.popoverShow5 = false;
      } else {
        this.popoverShow5 = true;
        createPopper(this.$refs.btnRef5, this.$refs.popoverRef5, {
          placement: "top"
        });
      }
    },




  },
  components: {
    // TableDropdown,
  },
  props: {
    color: {
      default: "light",
      validator: function (value) {
        // The value must match one of these strings
        return ["light", "dark"].indexOf(value) !== -1;
      },
    },
  },
};
</script>
